export enum HttpHeaderKey {
    ACCEPT = <any>"Accept",
    AUTHORIZATION = <any>"Authorization",   
    AUTHTOKEN = <any>"Auth-Token",
    ACCEPTENCODING = <any>"Accept-Encoding",
    CONTENTTYPE = <any>"Content-Type",
    CACHECONTROL = <any>"Cache-Control",
    EXPECT = <any>"Except",
    ORGANIZATION = <any>"Organization",   
}
export enum CookiesKey {
    TOKEN = <any>"token",
    SESSIONTIME = <any>"sessiontime",
    USERNAME = <any>"username",
    PASSWORD = <any>"password",
    ORGANIZATION=<any>"organization",
    ROLE=<any>"role",
    EXPIRETIME = <any>864000
}


// WEBPACK FOOTER //
// ./src/app/shared/enum/http-header-key.enum.ts